/* Zoo Snoods product page v2 behavior.
   - Gallery: thumbnail column + mobile dots drive Ella's main slider (.productView-nav, slick).
   - Fit line, sticky bar: follow the selected variant (Ella sets form input[name="id"] and fires "change").
   - Quick answers: numbers and visibility come from the chapters section (data-zs-num).
   - Chapters: scroll-spy for the desktop menu and the mobile chips.
   - Buy 2 Get 1 box: reads /cart?view=zs_bundle and window.ZsBundle.model (read only; the bundle logic lives in zs-bundle.js).
   - Sticky bar: shows when the main Add to Cart scrolls out of view; its button presses the main button.
   Mobile breakpoint: under 750px. */
(function () {
  if (window.__zsPdp) return;
  window.__zsPdp = true;

  var desktop = window.matchMedia('(min-width: 750px)');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- sticky header offset (same rule as zs-bundle.js) ---------- */

  function headerBottom() {
    var bottom = 0;
    $$('.shopify-section-group-header-group, sticky-header, .header-sticky').forEach(function (h) {
      var pos = window.getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var b = h.getBoundingClientRect();
      if (b.top <= 1 && b.bottom > bottom && b.height < window.innerHeight / 2) bottom = b.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  // Ella's mobile bottom menu (Home / Shop / Account / Cart) is fixed to the bottom; the sticky bar sits on top of it.
  function toolbarHeight() {
    var t = document.querySelector('.halo-sticky-toolbar-mobile');
    if (!t) return 0;
    var c = window.getComputedStyle(t);
    if (c.display === 'none' || c.visibility === 'hidden') return 0;
    var b = t.getBoundingClientRect();
    if (!b.height || b.top >= window.innerHeight) return 0;
    return Math.max(0, Math.round(window.innerHeight - b.top));
  }

  var lastTop = -1;
  var lastBottom = -1;
  function syncStickyTop() {
    var top = headerBottom();
    if (top !== lastTop) {
      lastTop = top;
      document.documentElement.style.setProperty('--zs-sticky-top', top + 'px');
    }
    var bottom = toolbarHeight();
    if (bottom !== lastBottom) {
      lastBottom = bottom;
      document.documentElement.style.setProperty('--zs-bar-bottom', bottom + 'px');
    }
  }

  /* ---------- variant helpers ---------- */

  function variantData() {
    var s = document.querySelector('.zs-pdp-main variant-radios script[type="application/json"], .zs-pdp-main variant-selects script[type="application/json"]');
    if (!s) return [];
    try { return JSON.parse(s.textContent) || []; } catch (e) { return []; }
  }

  function findVariant(id) {
    id = String(id);
    var list = variantData();
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) return list[i];
    return null;
  }

  var variantListeners = [];
  function onVariantChange(cb) { variantListeners.push(cb); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    // form.id would return the form's <input name="id">, so read the attribute.
    if (!t || t.name !== 'id' || !t.form || !/^product-form-/.test(t.form.getAttribute('id') || '')) return;
    if (!t.closest('.zs-pdp-main')) return;
    var v = findVariant(t.value);
    if (!v) return;
    variantListeners.forEach(function (cb) { try { cb(v); } catch (err) { /* keep going */ } });
  }, true);

  function formatMoney(cents) {
    var html;
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      html = window.Shopify.formatMoney(cents, window.money_format || '${{amount}}');
    } else {
      html = '$' + (cents / 100).toFixed(2);
    }
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent;
  }

  /* ---------- gallery ---------- */

  function initGallery(main) {
    var nav = main.querySelector('.productView-nav');
    var thumbs = $$('[data-zs-thumb]', main);
    var dots = $$('.zs-dots__d', main);
    if (!nav || (!thumbs.length && !dots.length) || nav.__zsGallery) return;
    nav.__zsGallery = true;

    function setActive(i) {
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && t.parentNode && desktop.matches) {
        var col = t.parentNode;
        if (t.offsetTop < col.scrollTop || t.offsetTop + t.offsetHeight > col.scrollTop + col.clientHeight) {
          col.scrollTo({ top: t.offsetTop - 10, behavior: 'smooth' });
        }
      }
    }

    var jq = window.jQuery;
    if (jq) {
      jq(nav).on('beforeChange', function (e, slick, cur, next) { if (e.target === nav) setActive(next); });
      jq(nav).on('afterChange', function (e, slick, cur) { if (e.target === nav) setActive(cur); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-zs-thumb'), 10) || 0;
        if (jq && jq(nav).hasClass('slick-initialized')) jq(nav).slick('slickGoTo', i);
        setActive(i);
      });
    });
    initThumbArrows(main);
  }

  // Up/down arrows on the desktop thumbnail column: shown only when it overflows, each click scrolls a page,
  // and at the bottom (top) the next click wraps back to the top (bottom).
  function initThumbArrows(main) {
    var wrap = main.querySelector('[data-zs-thumbs-wrap]');
    var col = wrap && wrap.querySelector('[data-zs-thumbs]');
    if (!col || wrap.__zsArrows) return;
    wrap.__zsArrows = true;
    var up = wrap.querySelector('[data-zs-thumbs-step="-1"]');
    var down = wrap.querySelector('[data-zs-thumbs-step="1"]');

    function update() {
      wrap.classList.toggle('is-scrollable', col.scrollHeight > col.clientHeight + 1);
    }
    [up, down].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-zs-thumbs-step'), 10);
        var max = col.scrollHeight - col.clientHeight;
        if (dir > 0 && col.scrollTop >= max - 1) { col.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && col.scrollTop <= 1) { col.scrollTo({ top: max, behavior: 'smooth' }); return; }
        var first = col.querySelector('[data-zs-thumb]');
        var step = first ? first.offsetHeight + 10 : 80;
        var visible = Math.floor((col.clientHeight + 10) / step);
        var page = Math.max(1, visible - 1) * step;
        col.scrollBy({ top: dir * page, behavior: 'smooth' });
      });
    });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(wrap);
    update();
  }

  /* ---------- fit line ---------- */

  function initFitLine(main) {
    var el = main.querySelector('[data-zs-fitline]');
    if (!el || el.__zsFit) return;
    el.__zsFit = true;
    var map = {};
    try { map = JSON.parse(el.querySelector('[data-zs-fit-map]').textContent) || {}; } catch (e) { map = {}; }
    var textEl = el.querySelector('[data-zs-fit-text]');
    onVariantChange(function (v) {
      var text = '';
      (v.options || []).forEach(function (o) {
        var k = String(o).trim().toLowerCase();
        if (map[k]) text = map[k];
      });
      textEl.textContent = text;
      el.classList.toggle('is-empty', !text);
      el.classList.remove('is-waiting');
    });
  }

  /* ---------- quick answers ---------- */

  function initQuickAnswers() {
    $$('[data-zs-qa]').forEach(function (qa) {
      var any = false;
      $$('[data-zs-qa-row]', qa).forEach(function (row) {
        var ch = document.getElementById('zs-ch-' + row.getAttribute('data-zs-qa-row'));
        if (!ch) { row.hidden = true; return; }
        row.hidden = false;
        any = true;
        var num = row.querySelector('[data-zs-qa-num]');
        if (num) num.textContent = ch.getAttribute('data-zs-num') || '';
      });
      qa.classList.toggle('is-empty', !any);
      qa.classList.add('is-ready');
    });
  }

  /* ---------- in-page links (#zs-…) ---------- */

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#zs-"]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('href').slice(1));
    if (!el) return;
    e.preventDefault();
    syncStickyTop();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- chapters: scroll-spy ---------- */

  function initChapters(root) {
    if (root.__zsChapters) return;
    root.__zsChapters = true;
    var cards = $$('[data-zs-chapter]', root);
    var links = $$('[data-zs-nav]', root);
    var chips = root.querySelector('.zs-chips');
    if (!cards.length || !links.length) return;
    var current = null;
    var locked = false;
    var idle = null;

    function setActive(key) {
      if (key === current) return;
      current = key;
      links.forEach(function (l) {
        var on = l.getAttribute('data-zs-nav') === key;
        l.classList.toggle('is-active', on);
        if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
        if (on && chips && l.parentNode === chips && !desktop.matches) {
          chips.scrollTo({ left: Math.max(0, l.offsetLeft - 16), behavior: 'smooth' });
        }
      });
    }

    function spy() {
      if (locked) return;
      var line = headerBottom() + (desktop.matches ? 140 : 120);
      var active = cards[0];
      cards.forEach(function (c) { if (c.getBoundingClientRect().top - line <= 0) active = c; });
      // At the very bottom of the page the last chapter may never reach the line; count it then.
      // (Only then: short last cards are often fully in view while an earlier chapter is being read.)
      var doc = document.documentElement;
      if (window.scrollY + window.innerHeight >= doc.scrollHeight - 2) {
        var lb = cards[cards.length - 1].getBoundingClientRect();
        if (lb.top < window.innerHeight) active = cards[cards.length - 1];
      }
      setActive(active.getAttribute('data-zs-chapter'));
    }

    // A menu/chip click highlights its chapter right away and holds it until the smooth scroll settles.
    links.forEach(function (l) {
      l.addEventListener('click', function () {
        setActive(l.getAttribute('data-zs-nav'));
        locked = true;
        clearTimeout(idle);
        idle = setTimeout(function () { locked = false; }, 1200);
      });
    });

    var raf = null;
    window.addEventListener('scroll', function () {
      if (locked) {
        clearTimeout(idle);
        idle = setTimeout(function () { locked = false; spy(); }, 200);
        return;
      }
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; spy(); });
    }, { passive: true });
    window.addEventListener('resize', spy);
    spy();
  }

  /* ---------- Buy 2 Get 1 box: squares from the shopper's cart ---------- */

  function initOffer() {
    var box = document.querySelector('[data-zs-offer][data-live]');
    if (!box || box.__zsOffer) return;
    box.__zsOffer = true;
    var wrap = box.querySelector('[data-zs-offer-squares]');
    var status = box.querySelector('[data-zs-offer-status]');
    var thumb = box.getAttribute('data-thumb');
    var freeLabel = box.getAttribute('data-free') || 'FREE';

    function fill(str, vals) {
      return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return k in vals ? vals[k] : m; });
    }

    function sq(cls, inner) {
      var s = document.createElement('span');
      s.className = 'zs-offer__sq ' + cls;
      if (inner) s.appendChild(inner);
      return s;
    }

    function img(src) {
      var i = document.createElement('img');
      i.src = src; i.alt = ''; i.width = 40; i.height = 40; i.loading = 'lazy';
      return i;
    }

    function render(d) {
      if (!d || !window.ZsBundle || typeof window.ZsBundle.model !== 'function') return;
      var m = window.ZsBundle.model(d);
      var row = (m.mod === 0 && m.fc > 0) ? m.rows[m.fc - 1] : m.rows[m.rows.length - 1];
      if (!row) return;
      var units = row.units || [];
      var filled = units.filter(Boolean).length;
      var placedThumb = false;
      var frag = document.createDocumentFragment();
      for (var pos = 0; pos < 3; pos++) {
        var u = units[pos];
        if (u) {
          var s = sq('zs-offer__sq--filled', u.image ? img(u.image) : null);
          if (row.done && pos === 2) {
            var tag = document.createElement('span');
            tag.className = 'zs-offer__tag';
            tag.textContent = freeLabel;
            s.appendChild(tag);
          }
          frag.appendChild(s);
        } else if (pos === 2) {
          var f = sq('zs-offer__sq--free');
          f.textContent = freeLabel;
          frag.appendChild(f);
        } else if (!placedThumb && thumb) {
          placedThumb = true;
          frag.appendChild(sq('zs-offer__sq--img' + (filled ? ' zs-offer__sq--next' : ''), img(thumb)));
        } else {
          frag.appendChild(sq('zs-offer__sq--empty'));
        }
      }
      wrap.innerHTML = '';
      wrap.appendChild(frag);

      var text = '';
      if (m.n > 0) {
        text = row.done
          ? fill(box.getAttribute('data-status-done'), { free: m.fc, n: 3, left: 0 })
          : fill(box.getAttribute('data-status-partial'), { n: filled, left: 3 - filled, free: m.fc });
      }
      status.textContent = text;
      status.hidden = !text;
    }

    function load() {
      fetch('/cart?view=zs_bundle', { cache: 'no-store' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var d = JSON.parse(t);
          if (d && Array.isArray(d.items) && (!d.items.length || 'eligible' in d.items[0])) render(d);
        })
        .catch(function () { /* keep the static box */ });
    }

    load();
    var drawer = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    if (drawer) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; load(); }, 150);
      }).observe(drawer, { childList: true });
    }
    document.addEventListener('cart-update', load);
    window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
  }

  /* ---------- sticky Add to Cart bar ---------- */

  function initSticky() {
    var bar = document.querySelector('[data-zs-sticky]');
    if (!bar || bar.__zsSticky) return;
    bar.__zsSticky = true;
    var pid = bar.getAttribute('data-product-id');
    var form = document.getElementById('product-form-' + pid);
    var mainBtn = form && form.querySelector('[name="add"]');
    var watch = document.querySelector('.zs-pdp-main .productView-buttons') || mainBtn;
    if (!mainBtn || !watch) return;

    // Fixed bars misbehave inside transformed ancestors; move it to <body>.
    document.body.appendChild(bar);
    document.documentElement.classList.add('zs-has-sticky');

    var atc = bar.querySelector('[data-zs-sticky-atc]');
    var price = bar.querySelector('[data-zs-sticky-price]');
    var sizes = $$('[data-zs-sticky-size]', bar);

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      atc.tabIndex = on ? 0 : -1;
      sizes.forEach(function (s) { s.tabIndex = on ? 0 : -1; });
    }
    setVisible(false);

    // Visible once the main button has scrolled up out of view (a scroll check; an unreferenced
    // IntersectionObserver was garbage-collected in testing and stopped firing).
    var shown = null;
    function check() {
      var on = watch.getBoundingClientRect().bottom < 0;
      if (on !== shown) { shown = on; setVisible(on); }
    }
    var raf = null;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = null; check(); });
    }, { passive: true });
    window.addEventListener('resize', check);
    check();

    function syncButton() {
      atc.disabled = !!mainBtn.disabled;
      var label = (mainBtn.textContent || '').trim();
      if (label) atc.textContent = label;
    }

    // Ella doesn't preselect a size. With none picked, take the shopper to the size selector instead
    // of pressing the main button (whose "pick a size" message would be off screen).
    function needsSize() {
      var radios = $$('.zs-pdp-main variant-radios input[type="radio"]');
      if (!radios.length) return false;
      return !radios.some(function (r) { return r.checked; });
    }

    atc.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      if (needsSize()) {
        var picker = document.querySelector('.zs-pdp-main .productView-variants');
        if (picker) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          picker.classList.remove('zs-pulse');
          void picker.offsetWidth;
          picker.classList.add('zs-pulse');
        }
        return;
      }
      mainBtn.click();
    });

    sizes.forEach(function (b) {
      b.addEventListener('click', function () {
        var opt = b.getAttribute('data-option');
        var val = b.getAttribute('data-zs-sticky-size');
        var radios = $$('.zs-pdp-main variant-radios input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].name === opt && radios[i].value === val) { radios[i].click(); return; }
        }
        var selects = $$('.zs-pdp-main variant-selects select');
        selects.forEach(function (s) {
          if (s.name === 'options[' + opt + ']') {
            s.value = val;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    onVariantChange(function (v) {
      if (price) price.textContent = formatMoney(v.price);
      sizes.forEach(function (b) {
        var on = (v.options || []).indexOf(b.getAttribute('data-zs-sticky-size')) !== -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      setTimeout(syncButton, 60);
    });
    syncButton();
  }

  /* ---------- Customer Reviews: "Write a review" opens Judge.me's form ---------- */

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zs-write-review]');
    if (!b) return;
    // New Judge.me widget (app block): its own button, hidden by CSS, opens the write-a-review popup.
    var jm = document.querySelector('#zs-reviews .jm-action-buttons__button');
    if (jm) { jm.click(); return; }
    var link = document.querySelector('#zs-reviews .jdgm-write-rev-link');
    if (!link) return;
    link.click();
    setTimeout(function () {
      var f = document.querySelector('#zs-reviews .jdgm-form-wrapper');
      if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 250);
  });

  /* ---------- init ---------- */

  function init() {
    syncStickyTop();
    $$('.zs-pdp-main').forEach(function (main) {
      initGallery(main);
      initFitLine(main);
    });
    initQuickAnswers();
    $$('[data-zs-chapters]').forEach(initChapters);
    initOffer();
    initSticky();
  }

  var raf = null;
  window.addEventListener('scroll', function () {
    if (raf) return;
    raf = window.requestAnimationFrame(function () { raf = null; syncStickyTop(); });
  }, { passive: true });
  window.addEventListener('resize', syncStickyTop);
  document.addEventListener('shopify:section:load', init);
  onReady(init);
})();
